import cs_CZ from "../../intl/compiled/cs-CZ.json";
import de_DE from "../../intl/compiled/de-DE.json";
import en_US from "../../intl/compiled/en-US.json";
import es_ES from "../../intl/compiled/es-ES.json";
import fr_FR from "../../intl/compiled/fr-FR.json";
import hr_HR from "../../intl/compiled/hr-HR.json";
import it_IT from "../../intl/compiled/it-IT.json";
import pl_PL from "../../intl/compiled/pl-PL.json";
import pt_PT from "../../intl/compiled/pt-PT.json";
import type { SupportedLocale } from "../types/types";

export const getMessages = (locale: SupportedLocale) => {
	return { en_US, fr_FR, es_ES, de_DE, cs_CZ, hr_HR, it_IT, pl_PL, pt_PT }[locale.replaceAll("-", "_")];
};
